import { download, get } from './api';
import routes from './end-points';

export const adminReportApi = {
  initFunds: () => get(routes.adminReport.initFunds),
  initMainReport: (fundId) => get(routes.adminReport.initMainReport(fundId)),
  initDeptsMonthly: () => get(routes.adminReport.initDeptsMonthly),
  downloadDeptsMonthly: (id, mimeType) => download(routes.adminReport.downloadDeptsMonthly, mimeType),
};
